<section class="wrapper">
    <form [formGroup]="form">
        <header>
            <div class="breadcrumb">
                <span class="icon icon-caret-left"></span>
                <div class="breadcrumb-link" (click)="goBack()">
                    {{ 'pages.services-state.configuration.create.header.breadcrumb' | translate }}
                </div>
            </div>
            <div class="title">
                <h1>{{ title }}</h1>
                <button
                    (click)="handlePreviewServiceClick()"
                    class="bciti-button bciti-button--blue">
                    {{ 'pages.services-state.configuration.create.form.preview' | translate }}
                </button>
            </div>
        </header>
        <section>
            <h2>{{ 'pages.services-state.configuration.create.form.sections.general-information.title' | translate }}</h2>
            <div class="add-image">
                <img class="add-image__preview" *ngIf="imagePreview" [src]="imagePreview" alt="">
                <button 
                    *ngIf="!imagePreview"
                    type="button" 
                    class="save-button bciti-button bciti-button--blue-inversed"
                    (click)="handleAddImageClick()"
                >
                    {{ 'pages.services-state.configuration.create.form.sections.general-information.button.image' | translate }}
                </button>
                <div class="add-image__actions" *ngIf="imagePreview">
                    <!-- In edit, cannot open image directly to the cropper, missing original File -->
                    <!-- We have to restart the process to the file-upload for now -->
                    <button type="button" (click)="isEditMode ? handleAddImageClick() : handleEditImageClick()">
                        <span class="icon icon-edit"></span>
                    </button>
                    <button type="button" (click)="handleClearImageClick()">
                        <span class="icon icon-close"></span>
                    </button>
                </div>
            </div>
            <div class="add-location">
                <button
                    *ngIf="!formattedAddress"
                    type="button" 
                    class="save-button bciti-button bciti-button--blue-inversed"
                    (click)="handleAddLocationClick()"
                >
                    {{ 'pages.services-state.configuration.create.form.sections.general-information.button.location' | translate }}
                </button>
                <div class="info-card" *ngIf="formattedAddress">
                    <div class="info-card__details">
                        <span class="icon icon-map"></span>
                        <span>{{ formattedAddress }}</span>
                    </div>
                    <div class="info-card__actions">
                        <button type="button" (click)="handleAddLocationClick()">
                            <span class="icon icon-edit"></span>
                        </button>
                        <button type="button">
                            <span class="icon icon-close" (click)="handleClearLocation()"></span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="sm-u-grid u-grid-cols-2 u-gap-4" formGroupName="name">
                <div *ngFor="let language of langs" class="lang-input-wrapper">
                    <app-form-input
                        [label]="'pages.services-state.configuration.create.form.sections.general-information.name.label.' + language | translate"
                        [placeholder]="'pages.services-state.configuration.create.form.sections.general-information.name.placeholder.' + language | translate"
                        [formControlName]="language"
                        [charLimit]="40"
                        [hint]="'pages.services-state.configuration.create.form.sections.general-information.name.hint' | translate"
                    >
                        <app-form-error *ngIf="name.get(language).touched && name.get(language).hasError('required')">
                            {{ 'pages.services-state.configuration.create.form.sections.general-information.name.errors.required' | translate }}
                        </app-form-error>
                    </app-form-input>
                </div>
            </div>
            <div class="sm-u-grid u-grid-cols-2 u-gap-4" formGroupName="resume">
                <div *ngFor="let language of langs" class="lang-input-wrapper">
                    <app-form-textarea
                        [label]="'pages.services-state.configuration.create.form.sections.general-information.resume.label.' + language | translate"
                        [placeholder]="'pages.services-state.configuration.create.form.sections.general-information.resume.placeholder.' + language | translate"
                        [formControlName]="language"
                        [charLimit]="250"
                        [hint]="'pages.services-state.configuration.create.form.sections.general-information.name.hint' | translate"
                    >
                        <app-form-error *ngIf="resume.get(language).touched && resume.get(language).hasError('required')">
                            {{ 'pages.services-state.configuration.create.form.sections.general-information.resume.errors.required' | translate }}
                        </app-form-error>
                    </app-form-textarea>
                </div>
            </div>
            <div class="md-u-grid u-grid-cols-2 u-gap-4">
                <div class="sm-u-grid u-grid-cols-2 u-gap-4">
                    <app-bciti-text-select 
                            formControlName="category"
                            [label]="'pages.services-state.configuration.create.form.sections.general-information.category.selectLabel' | translate"
                            [placeholder]="'pages.services-state.configuration.create.form.sections.general-information.category.placeholder' | translate"
                            [options]="categoryList">
                        <app-form-error *ngIf="category.touched && category.hasError('required')">
                            {{ 'pages.services-state.configuration.create.form.sections.general-information.category.errors.invalidCategory' | translate }}
                        </app-form-error>
                    </app-bciti-text-select>
                </div>
                <div class="sm-u-grid u-grid-cols-2 u-gap-4">
                    <app-bciti-text-select 
                            [label]="'pages.services-state.configuration.create.form.sections.statuses.selectAvailableLabel' | translate"
                            [placeholder]="'pages.services-state.configuration.create.form.sections.statuses.placeholder' | translate"
                            [options]="statusList"
                            formControlName="availableStatus">
                        <app-form-error *ngIf="availableStatus.touched && availableStatus.hasError('required')">
                            {{ 'pages.services-state.configuration.create.form.sections.statuses.errors.invalidStatus' | translate }}
                        </app-form-error>
                    </app-bciti-text-select>
                    <app-bciti-text-select 
                            [label]="'pages.services-state.configuration.create.form.sections.statuses.selectNotAvailableLabel' | translate"
                            [placeholder]="'pages.services-state.configuration.create.form.sections.statuses.placeholder' | translate"
                            [options]="statusList"
                            formControlName="nonAvailableStatus">
                        <app-form-error *ngIf="nonAvailableStatus.touched && nonAvailableStatus.hasError('required')">
                            {{ 'pages.services-state.configuration.create.form.sections.statuses.errors.invalidStatus' | translate }}
                        </app-form-error>
                    </app-bciti-text-select>
                </div>
            </div>
            <div class="section-cta">
                <button 
                    *ngIf="!link.value"
                    type="button" 
                    class="bciti-button bciti-button--blue-inversed"
                    (click)="handleAddCtaClick()"
                >
                    {{ 'pages.services-state.dialogs.add-cta-dialog.title' | translate }}
                </button>
                <div *ngIf="link.value" class="info-card">
                    <div class="info-card__details">
                        <span class="icon icon-link"></span>
                        <a [href]="link.value" target="_blank" class="bciti-link">{{ cta.value[currentLang] }}</a>
                    </div>
                    <div class="info-card__actions">
                        <button type="button" (click)="handleAddCtaClick()">
                            <span class="icon icon-edit"></span>
                        </button>
                        <button type="button" (click)="handleClearCta()">
                            <span class="icon icon-close"></span>
                        </button>
                    </div>
                </div>
            </div>
        </section>
        <section class="section-schedules">
            <section class="section-schedule section-schedule--default">
                <div class="section-schedule__title">
                    {{ 'pages.services-state.configuration.create.form.sections.schedules.default-schedule.title' | translate }}
                </div>
                <div *ngIf="defaultSchedule && defaultSchedule.schedule" class="schedules schedules--default">
                    <div class="schedules__actions">
                        <button class="schedules__edit" (click)="startCreatingDefaultSchedule()">
                            <span class="icon icon-edit"></span>
                        </button>
                    </div>
                    <div class="schedule" *ngFor="let day of objectKeys(defaultSchedule.schedule)">
                        <div class="schedule__day">
                            {{ 'pages.services-state.configuration.days-slice.' + day | translate }}
                        </div>
                        <ul class="schedule__list">
                            <li *ngFor="let timeSlot of defaultSchedule.schedule[day]; let i = index">
                               {{ timeSlot.from | timeFormat}} - {{ timeSlot.to | timeFormat}}
                            </li>
                            <li *ngIf="!defaultSchedule.schedule[day] || defaultSchedule.schedule[day]?.length === 0" class="schedule__closed">
                                {{ serviceNonAvailableStatusName || formNonAvailableStatusName }}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="section-schedule__display">
                    <app-form-checkbox formControlName="displaySchedules" [showMessages]="false">
                        {{ 'pages.services-state.configuration.create.form.sections.schedules.displaySchedules' | translate }}
                    </app-form-checkbox>
                </div>
            </section>

            <section class="section-schedule section-schedule--custom">
                <div class="section-schedule__title">
                    {{ 'pages.services-state.configuration.create.form.sections.schedules.custom-schedule.title' | translate }}
                </div>
                <div class="section-schedule__infos">
                    {{ 'pages.services-state.configuration.create.form.sections.schedules.custom-schedule.infos' | translate }}
                </div>
                <div>
                    <button type="button" class="section-schedule__button bciti-button bciti-button--blue-inversed" (click)="addCustomSchedule()">
                        {{ 'pages.services-state.configuration.create.form.sections.schedules.custom-schedule.button' | translate }}
                    </button>
                </div>
                <div *ngFor="let customSchedule of customSchedules; let index = index;">
                    <div *ngIf="customSchedule && customSchedule.schedule" class="schedules schedules--custom">
                        <div class="schedules__actions">
                            <button class="schedules__edit" (click)="startCreatingCustomSchedule(customSchedule, index)">
                                <span class="icon icon-edit"></span>
                            </button>
                            <button class="schedules__delete" (click)="handleDeleteCustomSchedule(index)">
                                <span class="icon icon-close"></span>
                            </button>
                        </div>
                        <div class="schedules__infos">
                            <div class="schedules__name">
                                {{ customSchedule.name[currentLang] }}
                            </div>
                            <div class="schedules__dates">
                                {{ customSchedule.from | date }}
                                <ng-container *ngIf="(customSchedule.to | date ) !== (customSchedule.from | date )">
                                    - {{ customSchedule.to | date }}
                                </ng-container>
                            </div>
                        </div>
                        <div class="schedule" *ngFor="let day of objectKeys(getSortedSchedule(customSchedule.schedule))">
                            <div class="schedule__day">
                                {{ 'pages.services-state.configuration.days-slice.' + day | translate }}
                            </div>
                            <ul class="schedule__list">
                                <li *ngFor="let timeSlot of customSchedule.schedule[day]">
                                    {{ timeSlot.from | timeFormat}} - {{ timeSlot.to | timeFormat}}
                                </li>
                                <li *ngIf="!customSchedule.schedule[day] || customSchedule.schedule[day]?.length === 0" class="schedule__closed">
                                    {{ 'pages.services-state.dialogs.service-schedule-dialog.closed' | translate }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </section>
        <footer>
            <div class="row">
                <button class="bciti-inline-button" (click)="goBack()">{{ 'pages.services-state.configuration.create.form.cancel' | translate }}</button>
                <button
                    class="bciti-button bciti-button--blue"
                    (click)="handleSubmit()"
                    [disabled]="submitLoading"
                >
                    <mat-progress-spinner
                        *ngIf="submitLoading"
                        mode="indeterminate" 
                        diameter="20"
                    ></mat-progress-spinner>
                    {{ 'pages.services-state.configuration.create.form.save' | translate }}
                </button>
            </div>
        </footer>
    </form>
</section>